import { useEffect, useState } from "react";
import { ChevronUpIcon } from "lucide-react";

const ScrollProgressBar = () => {
  const [scroll, setScroll] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const progress = (window.scrollY / totalHeight) * 100;
      setScroll(progress);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-4 right-4 w-12 h-12 rounded-full bg-white shadow-lg border flex items-center justify-center z-50 group cursor-pointer"
      title="Back to Top"
    >
      <svg className="absolute inset-0" viewBox="0 0 36 36">
        <defs>
          <linearGradient id="scrollGradient" gradientTransform="rotate(270.95)">
            <stop offset="0%" stopColor="#00A759" />
            <stop offset="87.52%" stopColor="#00A3D4" />
          </linearGradient>
        </defs>

        {/* Background circle */}
        <path
          strokeWidth="3"
          fill="none"
          stroke="#e5e7eb" // Tailwind gray-300
          d="M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831"
        />

        {/* Progress path with gradient */}
        <path
          strokeWidth="3"
          fill="none"
          strokeDasharray={`${scroll}, 100`}
          stroke="url(#scrollGradient)"
          d="M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831"
        />
      </svg>

      <ChevronUpIcon className="w-5 h-5 text-[#00A3D4] group-hover:text-[#00A759] transition" />
    </button>
  );
}

export default ScrollProgressBar;